<template>
  <div id="solution" class="c-content">
    <banner-general :content="banner"></banner-general>
    <div class="c-solution__technology c-standard">
      <h3 class='title_h3 relative'>
        <span>{{ technology.title }}</span>
        <div class="textBgCenter absolute" style='top: -50%'></div>
      </h3>
      <p>{{ technology.text }}</p>
      <div class="c-solution__technology--items">
        <div class="c-solution__technology--item" v-for="(item,index) in technology.items" :key="index">
          <img :src="item.img" :alt="item.text">
          <p>{{item.text}}</p>
        </div>
      </div>
    </div>
    <div class="c-drawer" :class="{'is-active': drawerActive}" :style="{backgroundImage:'url('+ drawer.img +')'}">
      <div :class="{'is-active': !drawerActive}" class="c-drawer__item c-drawer__left">
        <div class="c-drawer__text">
          <h3 class="title_h3" style="padding: 0 10px">{{ drawer.content[0].title }}</h3>
          <div class="c-drawer__content">
            <p v-for="(item, index) in drawer.content[0].items" :key="index">
              <b class='fa fa-angle-right' style='line-height: 1.5em'></b>
              <span>{{ item.content }}</span>
            </p>
          </div>
        </div>
      </div>
      <div :class="{'is-active': drawerActive}"  class="c-drawer__item c-drawer__right">
        <div class="c-drawer__text">
          <h3 class="title_h3" style="padding: 0 10px">{{ drawer.content[1].title }}</h3>
          <div class="c-drawer__content">
            <p v-for="(item, index) in drawer.content[1].items" :key="index">
              <!-- <b>{{ item.title }}</b> -->
              <b class='fa fa-angle-right' style='line-height: 1.5em'></b>
              <span>{{ item.content }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="c-drawer__arrow" @click="toggleDrawer()">
        <i class="fa fa-angle-left"></i>
      </div>
    </div>
    <div class="c-panelsTab__panels">
      <div class="c-panelsTab__panels--top">
        <p class='c-panelsTab__panel--tab' v-for="(item, index) in tabs" :class="index == tabIndex ? 'is-active' : ''" @click="chooseThis(index)">{{ item.text }}</p>
      </div>
    </div>
    <div class="c-panelsTab__content" v-for="(item, index) in tabs" v-show="index == tabIndex">
      <solution-info :type='index'></solution-info>
    </div>
  </div>
</template>

<script>
  import BannerGeneral from '../layout/bannerGeneral.vue'
  import SolutionInfo from '../layout/solutionInfo.vue'

  export default {
    name: 'solution',
    components: {
      'banner-general': BannerGeneral,
      'solution-info': SolutionInfo
    },
    data(){
      return {
        text: {
          more: this.$t('common.more')
        },
        banner: {
          type: '1',
          img: require('../../assets/img/banner_pension.jpg'),
          title: this.$t('solution.banner.title'),
          content: this.$t('solution.banner.content'),
        },
        technology: {
          title: this.$t('solution.technology.title'),
          text: "",
          items: [
            {img: require('../../assets/img/icon_iot.png'), text: this.$t('solution.technology.technology_1')},
            {img: require('../../assets/img/icon_cloud.png'), text: this.$t('solution.technology.technology_2')},
            {img: require('../../assets/img/icon_ai.png'), text: this.$t('solution.technology.technology_3')},
            {img: require('../../assets/img/icon_face.png'), text: this.$t('solution.technology.technology_4')},
            {img: require('../../assets/img/icon_video.png'), text: this.$t('solution.technology.technology_5')},
            {img: require('../../assets/img/icon_bigdata.png'), text: this.$t('solution.technology.technology_6')},
          ]
        },
        drawerActive: false,
        drawer: {
          img: require('../../assets/img/solution_demand.jpg'),
          content:[
            {
              title: this.$t('solution.drawer.left.title'),
              items:[
                {title: this.$t('solution.drawer.left.items.item_1.title'), content: this.$t('solution.drawer.left.items.item_1.content')},
                {title: this.$t('solution.drawer.left.items.item_2.title'), content: this.$t('solution.drawer.left.items.item_2.content')},
                {title: this.$t('solution.drawer.left.items.item_3.title'), content: this.$t('solution.drawer.left.items.item_3.content')},
              ]
            },
            {
              title: this.$t('solution.drawer.right.title'),
              items:[
                {title: this.$t('solution.drawer.right.items.item_1.title'), content: this.$t('solution.drawer.right.items.item_1.content')},
                {title: this.$t('solution.drawer.right.items.item_2.title'), content: this.$t('solution.drawer.right.items.item_2.content')},
                {title: this.$t('solution.drawer.right.items.item_3.title'), content: this.$t('solution.drawer.right.items.item_3.content')},
              ]
            },
          ]
        },
        tabs: [
          {text: this.$t('solution.panels.tabs.tab_1'), name: "homeCare"},
          {text: this.$t('solution.panels.tabs.tab_2'), name: "communityCare"},
          {text: this.$t('solution.panels.tabs.tab_3'), name: "organizationCare"},
        ],
        tabIndex: 0
      }
    },
    computed: {

    },
    created () {

    },
    methods: {
      routeTo(link, index){
        this.$router.push({
          name: link,
          query: {
            id: index
          }
        })
      },
      toggleDrawer(){
        this.drawerActive = !this.drawerActive
      },
      chooseThis(index){
        this.tabIndex = index
      }
    },
  }
</script>

<style>

</style>
